import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TravelCashApproveListComponent } from 'src/app/modules/travel-cash-advance/components/travel-cash-approve-list/travel-cash-approve-list.component';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { travelAuthorUrl, travelCashUrl, travelCashApproverUrl } from '../../common/api';
import { Travel } from 'src/app/models/travel';

@Component({
  selector: 'ark-report-unliquidated-detail',
  templateUrl: './report-unliquidated-detail.component.html',
  styleUrls: ['./report-unliquidated-detail.component.scss']
})
export class ReportUnliquidatedDetailComponent implements OnInit {

  keyWords = [];
  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  keyTable = '';

  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: any;
  dialogConfig:any;
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TravelCashApproveListComponent>,
    public travelService: TravelService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.getList();
  }

  getSelect(res){
    this.dialogRef.close(res);
  }

  getList() {
    let param = [];
    let queryString = '';

    if (this.page) {
      param.push('page='+this.page);
    }

    if (this.data.isemployee) {
      param.push('isemployee=true');
    }

    if (this.data.isdepartmet) {
      param.push('isdepartment=true');
    }
    
    if (this.data.days) {
      param.push('days='+this.data.days);
    }

    if (this.data.type) {
      param.push('type='+this.data.type);
    }

    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.travelService.url = travelCashApproverUrl+'/lookup'+ queryString;
    this.travelService.getFilter().subscribe(res=>{
      if (res.data.length) {
        this.travel = new Travel(res.data);
      } else {
        this.isNoResult = true;
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
    });
  }

  closeOnClick() {
    this.dialogRef.close('');
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }
}